import { z } from "zod";

export const HelpItem = z.object({
  title: z.string(),
  tooltip: z.string(),
  url: z.string(),
  afterIcon: z.string().optional(),
});
export type HelpItem = z.infer<typeof HelpItem>;
